export const DIALOG_WIDTH = 500;

export const ACCOUNT_LOCALE_LOCAL_STORAGE_KEY = 'account-locale';
